"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaletteColorEntry = exports.ColorManager = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _tinycolor = require("@ctrl/tinycolor");
var _remeda = require("remeda");
var _eventer = require("@blockwell/eventer");
class PaletteColorEntry {
  constructor(name, base) {
    (0, _defineProperty2.default)(this, "base", void 0);
    (0, _defineProperty2.default)(this, "text", void 0);
    (0, _defineProperty2.default)(this, "dark", void 0);
    (0, _defineProperty2.default)(this, "muted", void 0);
    (0, _defineProperty2.default)(this, "light", void 0);
    (0, _defineProperty2.default)(this, "transparent", void 0);
    (0, _defineProperty2.default)(this, "color", void 0);
    this.name = name;
    let color = (0, _tinycolor.tinycolor)(base);
    this.color = color;
    this.base = color.toString();
    this.text = (0, _tinycolor.mostReadable)(color, ["#fff", "#000"]).toString();
    this.dark = color.shade(15).toString();
    this.light = color.tint(15).toString();
    if (color.isDark()) {
      this.muted = color.tint(35).toString();
    } else {
      this.muted = color.shade(35).toString();
    }
    this.transparent = color.setAlpha(0.1).toString();
  }
}
exports.PaletteColorEntry = PaletteColorEntry;
const defaultColors = {
  primary: "#004fff",
  secondary: "#686868",
  tertiary: "#4c2a85",
  background: "#ffffff",
  text: "#020a1e",
  highlight: "#f2f4f6",
  link: "#004fff",
  warning: "#fdca40",
  danger: "#b80c09",
  success: "#4e9d3c"
};
const defaultRecent = ["#000000", "#ffffff", "rgba(0,0,0,0)", "#9b9b9b", '#2765be', "#d0021b", "#f8e71c", "#417505"];
class ColorManager {
  constructor(spec, registry) {
    (0, _defineProperty2.default)(this, "colors", {});
    (0, _defineProperty2.default)(this, "recent", []);
    (0, _defineProperty2.default)(this, "events", new _eventer.Eventer());
    this.spec = spec;
    this.registry = registry;
    for (let key of Object.keys(defaultColors)) {
      if (spec[key]) {
        this.colors[key] = new PaletteColorEntry(key, spec[key]);
      } else {
        this.colors[key] = new PaletteColorEntry(key, defaultColors[key]);
      }
    }
    this.emitUpdate();
  }
  updateColor(entry) {
    this.colors[entry.name] = entry;
    this.emitUpdate();
    this.spec[entry.name] = entry.base;
    this.registry.change({
      type: "color",
      "op": "update"
    });
  }
  addRecent(input) {
    let list = Array.isArray(input) ? input : [input];
    for (let it of list) {
      if (!it || it.startsWith("var(")) {
        continue;
      }
      let c = (0, _tinycolor.tinycolor)(it);
      let color = c.toString();
      this.recent = this.recent.filter(it => it !== color);
      this.recent.unshift(color);
    }
  }
  getRecent(count, excludeTheme = true) {
    let recent = [];
    let colors = excludeTheme ? Object.values(this.colors).flatMap(it => [it.base, it.light, it.dark]) : [];
    for (let color of this.recent) {
      if (!colors.includes(color)) {
        recent.push(color);
      }
      if (recent.length === count) {
        break;
      }
    }
    if (recent.length < count) {
      recent = (0, _remeda.uniq)(recent.concat(defaultRecent)).slice(0, count);
    }
    return recent;
  }
  toCss() {
    let css = {};
    for (let [key, val] of Object.entries(this.colors)) {
      css[`--${key}`] = val.base;
      css[`--${key}-text`] = val.text;
      css[`--${key}-dark`] = val.dark;
      css[`--${key}-light`] = val.light;
      css[`--${key}-muted`] = val.muted;
      css[`--${key}-transparent`] = val.transparent;
    }
    return " .palette-wrapper { " + Object.entries(css).map(([key, val]) => ` ${key}: ${val};`).join("\n") + " }";
  }
  toJSON() {
    return this.spec;
  }
  resolveColor(value) {
    if (value.startsWith("var(")) {
      let match = /var\(--([\w-]+)\)/.exec(value);
      let name = match[1];
      let variation;
      let split = name.split("-");
      if (split.length > 1 && ["dark", "light", "text"].includes(split[split.length - 1])) {
        name = split.slice(0, -1).join("-");
        variation = split[split.length - 1];
      }
      let color = this.colors[name];
      if (color) {
        switch (variation) {
          case "text":
            return color.text;
          case "dark":
            return color.dark;
          case "light":
            return color.light;
          default:
            return color.base;
        }
      }
    }
    return value;
  }
  emitUpdate() {
    this.events.emit("update", this.toCss());
  }
}
exports.ColorManager = ColorManager;
//# sourceMappingURL=ColorManager.js.map